module.exports = __webpack_public_path__ + "static/media/mushroom.6d3d8f3d.jpg";